export const MIME_TYPES = [
  // Text
  "text/plain",
  "text/html",
  "text/css",
  "text/javascript",
  "application/json",
  "application/xml",
  "text/csv",
  "text/tab-separated-values",

  // Image
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/svg+xml",
  "image/webp",
  "image/tiff",
  "image/x-icon",

  // Audio
  "audio/mpeg",
  "audio/wav",
  "audio/ogg",
  "audio/aac",
  "audio/flac",
  "audio/mp4",

  // Video
  "video/mp4",
  "video/webm",
  "video/quicktime",
  "video/x-msvideo",
  "video/x-flv",
  "video/avi",

  // Application
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/zip",
  "application/gzip",
  "application/x-rar-compressed",
  "application/x-tar",
  "application/java-archive",
  "application/x-shockwave-flash",

  // Font
  "font/woff",
  "font/woff2",
  "font/opentype",
  "font/truetype",
  "font/collection",

  // Model
  "model/iges",
  "model/vrml",
  "model/mesh",
  "model/obj",
  "model/stl",

  // Message
  "message/http",
  "message/imdn+xml",
  "message/partial",
  "message/rfc822",

  // Multipart
  "multipart/form-data",
  "multipart/byteranges",
  "multipart/alternative",
  "multipart/digest",
  "multipart/parallel",
  "multipart/related",
  "multipart/report",
  "multipart/signed",
  "multipart/encrypted",

  // Other
  "application/octet-stream",
  "application/x-www-form-urlencoded",
  "application/vnd.api+json",
  "application/ld+json",
  "application/problem+json",
];
